import { render, staticRenderFns } from "./CatalogsDisplay.vue?vue&type=template&id=c34e2068&scoped=true"
import script from "./CatalogsDisplay.vue?vue&type=script&lang=js"
export * from "./CatalogsDisplay.vue?vue&type=script&lang=js"
import style0 from "./CatalogsDisplay.vue?vue&type=style&index=0&id=c34e2068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34e2068",
  null
  
)

export default component.exports